import React, { useContext } from "react";
import { ResponsiveContext, Header, Box, Heading } from "grommet";
import { ConversationWithAI } from "./";
import { useTranslation } from "react-i18next";

export default function AskAI(props) {
  var contextSize = useContext(ResponsiveContext);
  if (contextSize !== "small") contextSize = "medium";
  const { t } = useTranslation();

  return (
    <Box
      align="stretch"
      justify="start"
      pad="medium"
      gap="medium"
      flex="grow"
      fill="horizontal"
      margin={{ bottom: "small" }}
    >
      <Header
        align="center"
        direction="row"
        fill="horizontal"
        className="details-header"
      >
        <Heading level="2" className="heading">
          {t("aiAssistant.title")}
        </Heading>
      </Header>
      <ConversationWithAI />
    </Box>
  );
}
